import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useConfirmDialog } from '../contexts/ConfirmDialogContext';

export default function ShireConfirmDialog() {
  const { isOpen, dialogData, closeConfirmDialog } = useConfirmDialog();

  const handleOk = () => {
    if (dialogData?.handleOnOk) {
      dialogData.handleOnOk();
    }
    closeConfirmDialog();
  };

  const handleCancel = () => {
    closeConfirmDialog();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      {dialogData && (
        <>
          <DialogTitle>
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
              {dialogData.title}
            </Typography>
          </DialogTitle>
          
          <DialogContent>
            <Box sx={{ mt: 1 }}>
              {typeof dialogData.content === 'string' ? (
                <Typography variant="body1" color="text.secondary">
                  {dialogData.content}
                </Typography>
              ) : (
                dialogData.content
              )}
            </Box>
          </DialogContent>
          
          <DialogActions sx={{ p: 3, pt: 1 }}>
            <Button
              onClick={handleCancel}
              variant="outlined"
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
